import React, { useState } from 'react';
import { withRouter } from "react-router-dom";
import { SlPageTitle, SlButton } from '../editors';
import { Row, Col } from "reactstrap";
import { metadataService } from '../../_services';
import { LeapTheoryForm } from './LeapTheoryForm';
import { GoodNews } from './GoodNews';
import { NoOffers } from './NoOffers';
import { connect } from "react-redux";


const DeclinedView = (props) => {

    const [declinedState, setDeclinedState] = useState({
        enableLeapTheory: props.configuration.leapTheoryEnabled,
        LeapTheoryDecision: "",
        redirectURL: "",
        leapTheoryTest: props.configuration.leapTheoryTest,
    })

    const handleContinue = () => {
        console.log(props.configuration)
        setDeclinedState(state => ({
            ...state,
            LeapTheoryDecision: "form"
        }))
    }

    if (declinedState.LeapTheoryDecision === "") {
        return (
            <div>
                <SlPageTitle pageName="ApplicationDeclined" />
                <Row>
                    <Col>
                        {!declinedState.enableLeapTheory &&
                            <div>
                                <p className={"text-center"}>{metadataService.getMessage("ApplicationDeclinedOriginal")}</p>
                                <p className={"text-center"}>{metadataService.getMessage("ApplicationDeclined2Original")}</p>
                            </div>
                        }
                        {declinedState.enableLeapTheory &&
                            <div>
                                <p className={"text-center"}>{metadataService.getMessage("ApplicationDeclined2")}
                                    <strong>{metadataService.getMessage("Continue")}</strong>
                                    {metadataService.getMessage("ApplicationDeclined3")}
                                </p>
                                < div className={"text-center"}>
                                    < SlButton name={"Continue"} size={"lg"} className={"text-center"} onClick={handleContinue} />
                                </div>
                            </div>
                        }
                    </Col>
                </Row>
                {!declinedState.enableLeapTheory &&
                    <Row>
                        <Col>
                            <br /><br />
                        </Col>
                        <p style={{ fontSize: "smaller" }} className={"text-center"}>{props.disclosure}</p>
                    </Row>
                }
            </div >
        )
    }
    if (declinedState.LeapTheoryDecision === "goodNews") {
        return <GoodNews redirectURL={declinedState.redirectURL} />
    }
    if (declinedState.LeapTheoryDecision === "noOffers") {
        return <NoOffers />
    }
    if (declinedState.LeapTheoryDecision === "form") {
        return <LeapTheoryForm setDeclinedState={setDeclinedState} leapTheoryTest={declinedState.leapTheoryTest} />
    }

}

function mapStateToProps(store) {

    const configuration = store.configuration;
    const { language } = store.users;



    return {
        configuration, language
    };
}

const declinedViewRouter = withRouter(DeclinedView);
const connectedDeclinedView = connect(mapStateToProps)(declinedViewRouter);
export { connectedDeclinedView as DeclinedView };